import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainCreatOrder(params) {
  return maintainRequest({
    url: `/fund/maintenanceMan/order/creatOrder`,
    params,
    method: "post",
  });
}
